import { inputBaseClasses } from "@mui/material/InputBase";
import TextField, { type TextFieldProps } from "@mui/material/TextField";
import type React from "react";
import { useTranslation } from "react-i18next";
import NoValue from "../../components/NoValue";

export type StringFieldArgs = {
  value: string;
  autoFocus?: boolean;
  disabled?: boolean;
  error?: boolean;
  name?: string;
  noValueLabel?: string | null | undefined;
  onBlur?: () => void;
  onChange?: (event: { target: { value: string } }) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  size?: "small" | "medium";
  slotProps?: TextFieldProps["slotProps"];
  variant?: "filled" | "outlined" | "standard";
  minLength?: number;
  "data-testid"?: string;
  fullWidth?: boolean;
  id?: string;
};

export default function StringField({
  value,
  disabled = false,
  error,
  name,
  noValueLabel,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  slotProps,
  variant = disabled ? "standard" : "outlined",
  ...props
}: StringFieldArgs): React.ReactNode {
  const { t } = useTranslation("common");
  return disabled && !value ? (
    <NoValue label={noValueLabel ?? t("values.none")} />
  ) : (
    <TextField
      onBlur={onBlur}
      variant={variant ?? "stardard"}
      disabled={disabled}
      value={value}
      onChange={onChange}
      name={name}
      size="small"
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      error={error}
      sx={(theme) => ({
        [`& .${inputBaseClasses.input}`]: {
          color: theme.palette.text.primary,
          WebkitTextFillColor: theme.palette.text.primary,
        },
      })}
      {...props}
      slotProps={slotProps}
    />
  );
}
